import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import ProtectionPlans from 'components/consumer/ProtectionPlans';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import StandardModal from 'components/consumer/StandardModal';
import MobileOnly from '../MobileOnly';
const ProtectionPlanModal = t0 => {
  const $ = _c(21);
  const {
    buttonRef,
    cartItemId,
    close: t1,
    eligiblePlans,
    forPage: t2,
    isOpen: t3,
    onSelect: t4,
    selectedPlan
  } = t0;
  const close = t1 === undefined ? _temp : t1;
  const forPage = t2 === undefined ? "cart" : t2;
  const isOpen = t3 === undefined ? false : t3;
  const onSelect = t4 === undefined ? null : t4;
  let t5;
  if ($[0] !== buttonRef || $[1] !== close) {
    t5 = e => {
      close(e);
      buttonRef?.current?.focus();
    };
    $[0] = buttonRef;
    $[1] = close;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const closeAndFocusOnButton = t5;
  let t6;
  if ($[3] !== close) {
    t6 = <MobileOnly><div className="max-[1023px]:hidden lg:hidden absolute top-2.5 right-4"><CtaButton styling="link" color="white" noLinkPadding={true} onClick={close} hasArrow={false}>No, thanks</CtaButton></div></MobileOnly>;
    $[3] = close;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-left text-white pt-0 px-0 pb-4 max-w-[80%] md:text-center md:max-w-full"><div className="text-2xl font-bold max-[1023px]:mx-0 max-[1023px]:-mt-2 max-[1023px]:mb-2">5-Year Protection Plans</div><div className="text-base text-white md:text-sm md:text-white">When an accident happens, know your investment is protected.</div></div>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== cartItemId || $[7] !== close || $[8] !== eligiblePlans || $[9] !== forPage || $[10] !== onSelect || $[11] !== selectedPlan) {
    t8 = <ProtectionPlans cartItemId={cartItemId} eligiblePlans={eligiblePlans} forPage={forPage} onAdd={close} onRemove={close} onSelect={onSelect} selectedPlan={selectedPlan} showImages={true} />;
    $[6] = cartItemId;
    $[7] = close;
    $[8] = eligiblePlans;
    $[9] = forPage;
    $[10] = onSelect;
    $[11] = selectedPlan;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-4"><div className="text-xs pt-4 px-0 text-center text-brand-lighter [&_svg]:top-1 [&_svg]:relative [&_svg]:ml-4 [&_a:visited]:visited:underline [&_a:visited]:visited:text-white"><span>In partnership with ServeCo. See the{" "}<a className="underline text-[inherit]" href="/furniture-protection-plan/" target="_blank">full terms here.</a></span></div></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t8) {
    t10 = <div className="w-full relative font-normal text-gray">{t6}{t7}{t8}{t9}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== closeAndFocusOnButton || $[18] !== isOpen || $[19] !== t10) {
    t11 = <StandardModal isOpen={isOpen} onClose={closeAndFocusOnButton} showOkButtonOnMobile={false} size="md" titleAlignment="center">{t10}</StandardModal>;
    $[17] = closeAndFocusOnButton;
    $[18] = isOpen;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
ProtectionPlanModal.propTypes = {
  buttonRef: PropTypes.object,
  cartItemId: PropTypes.string,
  close: PropTypes.func,
  eligiblePlans: PropTypes.array,
  forPage: PropTypes.oneOf(['cart', 'checkout', 'PDP', 'UserDashboardPP', 'UserDashboardOrdersPage']),
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  selectedPlan: PropTypes.object
};
export default withBrowserOnly(ProtectionPlanModal);
function _temp() {
  return null;
}